import { createI18n } from "vue-i18n";
import { en } from "@/i18n/en";
import { ja } from "@/i18n/ja";

const i18nMessages = {
  ja: ja,
  en: en,
};

export const i18n = createI18n({
  legacy: false,
  locale: "ja",
  messages: i18nMessages,
});
